export default __webpack_public_path__ + "static/media/marketplace-sales.f433f620.svg";